<h1 mat-dialog-title>Delete Appointment</h1>
<div mat-dialog-content>
  <p>Are you sure you want to delete this appointment?</p>
</div>
<div mat-dialog-actions class="justify-end">
  <button mat-button mat-dialog-close="no">Cancel</button>
  <button id="delete-btn" mat-button mat-dialog-close="yes" color="warn" cdkFocusInitial>Delete</button>
</div>